import React from 'react';
import { Link } from 'react-router'

function Tools({
  count,
  deletePartners
}) {
  return (
    <div className="admin_list">
      <h5>Partners (<span>{count}</span>)</h5>
      <Link className="button_classic" to="/partnership/new">Add partner</Link>
      <a className="button_delete" onClick={deletePartners}>Delete</a>
    </div>
  );
}

Tools.defaultProps = {};

Tools.propTypes = {};

export default Tools;



// WEBPACK FOOTER //
// ./src/components/Admin/Partner/Toolbar/Tools.jsx